export default "__VITE_PUBLIC_ASSET__1ce4628b__"